import store from "../../../../../store";
import { DomainRegistry } from "../../../../../domain";
import { Directory } from "../../../../../domain/drawing";
import { FormatReference } from "../../../../../domain/format";
import { ITreeSource, IEditTreeSource } from ".";
import { IConfiguration } from "../../../../../domain/configuration";

export class CommonDepartmentFavoriteFormatTreeSource implements ITreeSource<FormatReference>, IEditTreeSource<FormatReference> {
  constructor(private _shouldIgnoreChained: boolean, private _shouldIncludeReferenceableGroupFormats: boolean) {
  }

  private readonly config = store.getters.configuration as IConfiguration;
  public entityName: string = "全" + this.config.wording.common.departmentAsShort + "頻用" + this.config.wording.format.name + "情報";

  getTree(): Promise<Directory<string, FormatReference>[]> {
    const repository = DomainRegistry.format.getFormatRepository();
    return repository.getCommonDepartmentFavoriteFormats(this._shouldIgnoreChained, this._shouldIncludeReferenceableGroupFormats);
  }

  saveEditTree(treeSource: Directory<string, FormatReference>[]): Promise<void> {
    const repository = DomainRegistry.format.getFormatRepository();
    return repository.setCommonDepartmentFavoriteFormats(treeSource);
  }

  get managementKey(): string {
    return "*";
  }
}
